<template lang="pug">
#app
  template(v-if="isOffers")
    OffersDetailPage
  template(v-else)
    DetailPage
</template>

<script>
import DetailPage from './views/DetailPage'
import OffersDetailPage from './views/OffersDetailPage'

const url = new URLSearchParams(window.location.search)

export default {
  name: 'App',
  components: {
    DetailPage,
    OffersDetailPage
  },
  computed: {
    isOffers () {
      return url.get('is_offers') === 'true'
    }
  },
  created () {
    document.title = '\u200E'
    console.log(`%c version %c ${process.env.VUE_APP_VERSION} %c`, 'background: #35495e; padding: 1px; border-radius: 2px 0 0 2px; color: #fff;', 'background: #409EFF; padding: 1px; border-radius: 0 2px 2px 0; color: #fff;', 'background: transparent;')
  }
}
</script>
<style lang="stylus">
@import '~@/assets/reset.styl'
@import '~@/assets/App.styl'
</style>
